import { useSelector } from "react-redux";
import { useLazyGetOneContractQuery } from "../../../requests_cm/gecoContractsService/service";
import {
	ContractDetailType,
	ContractPeriodType,
} from "../../../requests_cm/gecoContractsService/types";
import { selectFeatureFlags } from "../../parameters/ParametersPage.selector";
import { FeatureName } from "../../../common/hooks/useFeatureFlags";

export function useGetContractPeriods() {
	const [getOneContract] = useLazyGetOneContractQuery();
	const features = useSelector(selectFeatureFlags);
	const getContractPeriods: (
		selectedContracts: ContractDetailType[],
		timezone: string | undefined
	) => Promise<[ContractPeriodType[], string | undefined]> = async (
		selectedContracts: ContractDetailType[],
		timezone: string | undefined
	) => {
		let tz = timezone;
		const gecoEndpoint = features[FeatureName.geco_endpoint] as string;
		const contractPeriodResponse = await Promise.all(
			selectedContracts.map(async (contract: ContractDetailType) => {
				try {
					const response = await getOneContract({
						endpoint: gecoEndpoint,
						contract_id: Number(contract.id),
						skip_validation: false,
					});
					// Set timezone from contract if not already set and contract has a timezone
					if (!timezone && response.data?.timezone) {
						tz = response.data?.timezone;
					}


					const cps = (response.data?.contract_periods || []).map((cp) => ({ ...cp, contractId: Number(contract.id), contractName: contract.name }));
					return cps;

				} catch (error) {
					console.warn(
						`Error fetching contract ${contract.id}:`,
						error
					);
					return [];
				}
			})
		);
		return [contractPeriodResponse.flat(1), tz];
	};

	return getContractPeriods;
}
